import React from "react";
import { Link } from "react-router-dom";
import { Container, Reveal, SectionHeading, useCollection } from "@/components/common";
import PageHero from "@/components/PageHero";
import { getContent } from "@/lib/api";
import { GraduationCap, BookOpen, VideoCamera, Users } from "@phosphor-icons/react";

const ICONS = { "Research Resources": BookOpen, "Reading Lists": BookOpen, "Clinical Insights": GraduationCap, Editorial: BookOpen, Videos: VideoCamera, Mentorship: Users };

export default function Education() {
  const { data } = useCollection(() => getContent("education_resources"), []);
  return (
    <div data-testid="education-page">
      <PageHero label="Education" title="Oncology Learning Academy"
        intro="Learning resources, clinical insights, lectures and mentorship for students, residents, young doctors and oncology professionals."
        image="https://images.unsplash.com/photo-1781746875712-fb3473667251?crop=entropy&cs=srgb&fm=jpg" />

      <section className="bg-white py-16">
        <Container>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {["Lectures & Videos", "Clinical Insights", "Journal Club", "Reading Lists", "Educational Articles", "Conference Talks", "Research Resources", "Career Guidance & Mentorship"].map((t, i) => (
              <Reveal key={t} delay={(i % 4) * 0.05}>
                <div className="h-full rounded-lg border border-slate-200 bg-softgrey-100 p-6">
                  <GraduationCap size={24} weight="light" className="text-gold-dark" />
                  <h3 className="mt-3 font-serif text-xl leading-snug text-navy">{t}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <section className="bg-softgrey-100 py-16">
        <Container>
          <SectionHeading label="Resources" title="Featured learning resources" />
          <div className="space-y-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200">
            {data.map((r) => {
              const Icon = ICONS[r.resource_type] || BookOpen;
              return (
                <div key={r.id} className="flex items-start gap-4 bg-white p-6">
                  <Icon size={22} className="mt-1 shrink-0 text-gold-dark" />
                  <div>
                    <div className="overline text-gold-dark">{r.category || r.resource_type}</div>
                    <h4 className="mt-1 font-serif text-xl text-navy">{r.title}</h4>
                    {r.description && <p className="mt-1 text-sm text-softgrey-600">{r.description}</p>}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-10 rounded-lg border border-slate-200 bg-white p-8 text-center">
            <h3 className="font-serif text-2xl text-navy">Interested in mentorship?</h3>
            <p className="mx-auto mt-2 max-w-xl text-sm text-softgrey-600">Dr. Sirohi is committed to mentoring the next generation of oncologists. Reach out to learn more.</p>
            <Link to="/contact" className="mt-5 inline-block"><button className="rounded-md bg-navy px-6 py-3 text-sm font-semibold text-white hover:bg-navy-700">Request Mentorship</button></Link>
          </div>
        </Container>
      </section>
    </div>
  );
}
